import React from 'react';
import { Route } from 'react-router-dom';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { loginRequest } from '../authConfig';

export default function ProtectedRoute({ component: Component, ...rest }) {
  const isAuthenticated = useIsAuthenticated();
  const { instance } = useMsal();

  return (
    <Route
      {...rest}
      render={props =>
        isAuthenticated ? (
          <Component {...props} />
        ) : (
          <div style={{ textAlign: 'center', padding: '80px 20px', color: '#ccc' }}>
            <p style={{ marginBottom: '16px' }}>You must be signed in to view this page.</p>
            <button
              onClick={() => instance.loginRedirect(loginRequest)}
              style={{ background: '#4BC4B9', color: '#1C2025', border: 'none', padding: '10px 24px', borderRadius: '6px', cursor: 'pointer', fontWeight: 600 }}
            >
              <i className='fab fa-microsoft' style={{ marginRight: '8px' }}></i>Sign In with Microsoft
            </button>
          </div>
        )
      }
    />
  );
}
